// this file is generated by update_shopify_store_data.py at 2026-01-26 20:22:06.125918
var courses = [];